const TRUSTED_COMPUTER_KEY = "TRUSTED_COMPUTER";
const TRUSTED_COMPUTER_CHANGED_EVENT = "trusted-computer-changed";
const PENDING_TRUSTED_COMPUTER_KEY = "PENDING_TRUSTED_COMPUTER";

// Preserve the selection across the SSO redirect without committing it.
export function stageTrustedComputerForSSO(trusted: boolean): void {
  sessionStorage.setItem(PENDING_TRUSTED_COMPUTER_KEY, String(trusted));
}

export function getPendingTrustedComputer(): boolean | undefined {
  const value = sessionStorage.getItem(PENDING_TRUSTED_COMPUTER_KEY);
  if (value === "true" || value === "false") {
    return value === "true";
  }
  return undefined;
}

export function clearPendingTrustedComputer(): void {
  sessionStorage.removeItem(PENDING_TRUSTED_COMPUTER_KEY);
}

export function isTrustedComputer(userId: string | undefined): boolean {
  if (!userId) {
    return false;
  }

  try {
    return localStorage.getItem(`${TRUSTED_COMPUTER_KEY}:${userId}`) === "true";
  } catch (error) {
    // Clear caches by default when the preference cannot be read.
    // oxlint-disable-next-line no-console
    console.warn("Failed to read trusted computer preference", error);
    return false;
  }
}

export function setTrustedComputer(userId: string, trusted: boolean): void {
  localStorage.setItem(`${TRUSTED_COMPUTER_KEY}:${userId}`, String(trusted));
  window.dispatchEvent(new Event(TRUSTED_COMPUTER_CHANGED_EVENT));
}

export function subscribeTrustedComputer(onChange: () => void): () => void {
  const onStorage = (event: StorageEvent) => {
    if (
      event.storageArea === localStorage &&
      (event.key === null || event.key.startsWith(`${TRUSTED_COMPUTER_KEY}:`))
    ) {
      onChange();
    }
  };

  window.addEventListener(TRUSTED_COMPUTER_CHANGED_EVENT, onChange);
  window.addEventListener("storage", onStorage);
  return () => {
    window.removeEventListener(TRUSTED_COMPUTER_CHANGED_EVENT, onChange);
    window.removeEventListener("storage", onStorage);
  };
}

export function shouldPreserveLogoutCache(
  userId: string | undefined,
  clearCache = false,
): boolean {
  return !clearCache && isTrustedComputer(userId);
}
